import { render, staticRenderFns } from "./IconQuickMenu.vue?vue&type=template&id=698e9532"
import script from "./IconQuickMenu.vue?vue&type=script&lang=js"
export * from "./IconQuickMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports